import api from './axios';

export const loginApi = (credentials) => api.post('/api/auth/login', credentials);
export const getMeApi = () => api.get('/api/auth/me');
